import React from 'react'
import PropTypes from 'prop-types'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import { Link } from 'react-router'
import Breadcrumb from 'component/Breadcrumb'

const LmExpress = (props) => {
  const { translate } = props

  const renderBreadcrumb = () => {
    const steps = [
      { link: '/', title: translate('mobile.home') },
      { title: translate('lmexpress.title') },
    ]

    return <Breadcrumb steps={steps} />
  }

  return (
    <div className='lmexpress-page'>
      {renderBreadcrumb()}

      <div className='margin-left-double margin-right-double'>
        <Row className='margin-bottom-double padding-bottom-double'>
          <div className='center'>
            <Col xs={12} sm={6} md={6}>
              <div className='rectangle border rounded padding-top-double'>
                <Link to='/lmexpress/previous-day'>
                  <div className='medium-icon margin-top'>
                    <i className='glyph glyph-clock' />
                  </div>
                  <h3 className='name color-text'>
                    {translate('mobile.previousDayLmExpress')}
                  </h3>
                </Link>
              </div>
            </Col>

            <Col xs={12} sm={6} md={6}>
              <div className='rectangle border rounded padding-top-double'>
                <Link to='/lmexpress/older'>
                  <div className='medium-icon margin-top'>
                    <i className='glyph glyph-calendar' />
                  </div>
                  <h3 className='name color-text'>
                    {translate('mobile.olderLmExpress')}
                  </h3>
                </Link>
              </div>
            </Col>
          </div>
        </Row>
      </div>
    </div>
  )
}

LmExpress.propTypes = {
  translate: PropTypes.func.isRequired,
}

export default LmExpress
